export const AuLawTable = ({ rows, testId, heading = "Laws" }) => (
  <div className="overflow-hidden rounded-xl border border-gray-200" data-testid={testId}>
    <table className="w-full text-left text-sm">
      <thead className="bg-surface2 text-ink">
        <tr>
          <th className="px-4 py-3 font-bold w-40">State / territory</th>
          <th className="px-4 py-3 font-bold">{heading}</th>
        </tr>
      </thead>
      <tbody className="divide-y divide-gray-200">
        {rows.map(([state, laws]) => (
          <tr key={state} className="align-top">
            <td className="px-4 py-3 font-semibold text-ink">{state}</td>
            <td className="px-4 py-3 text-ink-2">{laws}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
